// extracted by mini-css-extract-plugin
export var image = "subscribe-home-module--image--97dbd";
export var left = "subscribe-home-module--left--13476";
export var right = "subscribe-home-module--right--d0d68";
export var spin = "subscribe-home-module--spin--756d9";
export var subscribe = "subscribe-home-module--subscribe--746aa";
export var subscribe__college = "subscribe-home-module--subscribe__college--17e56";
export var subscribe__dailysports = "subscribe-home-module--subscribe__dailysports--e512e";
export var subscribe__home = "subscribe-home-module--subscribe__home--c26db";
export var subscribe__sportsbusiness = "subscribe-home-module--subscribe__sportsbusiness--d517d";
export var wrapper = "subscribe-home-module--wrapper--80f22";